<div class="careposi-header">
  <img class="hd-logo" src="images/logo/super-logo.svg" />
  <div class="hd-title"></div>
  <div class="hd-info" [class.is-collapsed]="infoCollapsed">
    <button
      class="info-toggle"
      type="button"
      (click)="toggleInfoPanel()"
      aria-label="Toggle info panel"
    ></button>
    <div class="info-content">
      <div class="user-info info-margin company-info" id="">
        <svg
          class="company-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            class="company-path"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 21h18M9 8h1m-1 4h1m-1 4h1m4-8h1m-1 4h1m-1 4h1M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"
          />
        </svg>
        <div class="label lb-office" (click)="showChangeOffice()">{{ officeName }}</div>
      </div>
      <div class="user-info info-margin" id="">
        <svg
          class="user-icon"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle class="head" cx="12" cy="8" r="5" />
          <path class="body" d="M20 21a8 8 0 0 0-16 0" />
        </svg>
        <div class="label lb-user-info" (click)="gotoProfile()">{{ userName }}</div>
      </div>
      <div class="user-info info-margin logout" (click)="onLogout()">
        <svg
          class="logout-icon"
          width="28"
          height="28"
          viewBox="-3 0 27 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline class="logout-move" points="16 17 21 12 16 7" />
          <line class="logout-move" x1="21" y1="12" x2="9" y2="12" />
        </svg>
        <div class="label">ログアウト</div>
      </div>
    </div>
  </div>
</div>
<careposi-dialog-office-secletion
  (onSubmitData)="onSubmitData($event)"
  [isDisplayModal]="isShowDialog">
</careposi-dialog-office-secletion>